class TabsDirective {
    constructor($rootScope, $window) {
        this.$rootScope = $rootScope;
        this.restrict = 'A';
        this.$window = $window;
    }

    getBindingMap(element, targetIds) {
        if (targetIds.length < 1) {
            console.error('TabsDirective::wrongTargets', targetIds);
            return null;
        }
        
        const targets = targetIds
            .map(id => document.getElementById(id))
            .filter(target => target != null)
            .map(target => angular.element(target));

        if (targets.length < 1 || targets.length != targetIds.length) {
            console.error('TabsDirective::wrongTargets', targetIds);
            return null;
        }

        const buttons = Array.prototype.slice.call(element.find('button'))
            .map(button => angular.element(button));

        if (buttons.length != targetIds.length) {
            console.error(`TabsDirective::buttonsLengthMismatchTargets ${buttons.length} != ${targetIds.length}`);
            return null;
        }

        let mapData = [];

        for (let i = 0; i < buttons.length; i++) {
            mapData.push([buttons[i], targets[i]]);
        }

        return new Map(mapData);
    }

    link(scope, element, attrs, controllers) {
        if (!attrs.targets) {
            console.error('TabsDirective::targetsUndefined', targetIds);
            return;
        }

        const supportsMatchMedia = this.$window.matchMedia !== undefined && !!this.$window.matchMedia('all').addListener;

        const parent = element.parent();

        const targetIds = attrs.targets.split(',');

        const bindingMap = this.getBindingMap(element, targetIds);

        if (!bindingMap || bindingMap.length < 2) return;

        const onClick = (event, button, target) => {
            parent[0].style.minHeight = parent[0].clientHeight + 'px';

            console.log('TabsDirective::parentMinHeight', parent, parent[0].clientHeight + 'px');

            for (const [button, target] of bindingMap.entries()) {
                button.removeClass('active');
                target.removeClass('open');
            }

            button.addClass('active');
            target.addClass('open');

            parent[0].style.minHeight = '';

            this.$rootScope.$broadcast('tabs-change', target);
        };

        for (const [button, target] of bindingMap.entries())
            button.on('click', event => onClick(event, button, target));

        let hasOpenedPair = false;

        for (const [button, target] of bindingMap.entries()) {
            if (button.hasClass('active') && target.hasClass('open')) hasOpenedPair = true;
        }

        if (!hasOpenedPair && supportsMatchMedia && this.$window.matchMedia("(min-width: 768px)").matches) {
            const [button, target] = bindingMap.entries().next().value;
            button.addClass('active');
            target.addClass('open');
        }

        scope.$on('$destroy', () => {
            for (const button of buttons)
                button.off('click', onClick);
        });
    }

    static directiveFactory($rootScope, $window) {
        'ngInject';
        return new TabsDirective($rootScope, $window);
    }
}

export default TabsDirective;